import { render, staticRenderFns } from "./humanResources.vue?vue&type=template&id=9ca5b112&"
import script from "./humanResources.vue?vue&type=script&lang=js&"
export * from "./humanResources.vue?vue&type=script&lang=js&"
import style0 from "./humanResources.vue?vue&type=style&index=0&id=9ca5b112&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports